
<div class="container-header">
    <div class="page-header-filter">
        <h3 class="page-header-title">{{pageTitle}}</h3>

        <div class="page-header-filter-and-date-selector d-sm-flex">
            <saved-filter-selector [filters]="namedFilters"
                                   [selectedNamedFilter]="selectedNamedFilter"
                                   [createLink]="!managerInDialog"
                                   (onSelectionChange)="onSelectedFilterChange($event)"></saved-filter-selector>

            @if(manageDate){
                <tm-date-range-picker [formControl]="dateIntervalCtrl" [presetIds]="presetIds" [maxDate]="maxDate"></tm-date-range-picker>
            }
        </div>

        @if(selectedNamedFilter?.decodedFilter){
            <saved-filter-manager   [filter]="selectedNamedFilter"
                                    [show]="filterManagerOpen"
                                    [managerMode]="managerMode"
                                    [managerInDialog]="managerInDialog"
                                    [isFilterUpdated]="isFilterUpdated"
                                    (setAsDefault)="set_as_default(selectedNamedFilter.id)"
                                    (onCreateOrUpdateFilter)="onCreateOrUpdateFilter(selectedNamedFilter)"
                                    (filterChange)="onFilterChange($event)"></saved-filter-manager>
        }
    </div>
</div>